/* 🤖 this file was generated by svg-to-ts */
export const matIconDehaze: {
  name: 'dehaze';
  data: string;
} = {
  name: 'dehaze',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M2 16v2h20v-2H2zm0-5v2h20v-2H2zm0-5v2h20V6H2z"/></svg>`
};
